// extracted by mini-css-extract-plugin
export default {"close-icon":"i5TG7pQbglGBCg3C4dSa","select":"jBcWWqekc4nIixboEJUh"};